import classNames from 'classnames';
import {
	GameAssignmentContext,
	IGameAssignmentContext,
} from 'modules/Entertainment/Games/GameAssignment/gameAssignmentState/gameAssignmentContext';
import React, { useContext, useEffect } from 'react';
import CustomerCrumb from './components/CustomerCrumb';
import RestaurantCrumb from './components/RestaurantCrumb';
import GameCrumb from './components/GameCrumb';
import style from './Breadcrumbs.module.scss';

const Breadcrumbs: React.FC = () => {
	const { setShowBreadcrumbs, isShowBreadcrumbs, IDsSelectedCustomers } =
		useContext<IGameAssignmentContext>(GameAssignmentContext);

	const containerClasses = classNames(style.container, { [style.hidden]: !isShowBreadcrumbs });

	const emptyCustomers = !Object.keys(IDsSelectedCustomers).length;

	useEffect(() => {
		emptyCustomers && setShowBreadcrumbs(false);
	}, [emptyCustomers]);

	return (
		<div className={containerClasses} data-test="Breadcrumbs">
			<CustomerCrumb />
			<RestaurantCrumb />
			<GameCrumb />
		</div>
	);
};

export default Breadcrumbs;
